import { checkoutMobx, storeMobx } from '@mobxStore'
import { getHistoryNew } from '@utils'
import React, { FC } from 'react'
import './index.scss'

const PickupWaiter: FC = () => {
  const history = getHistoryNew()
  return (
    <div className='cart-waiter-footer'>
      <div className='cwf-wrapper'>
        <div className='cwf-info'>
          <i className='iconfont icon-clock'></i>
          <div>
            <h3>{i18n.t('checkout.pickupContactWaiterToOrder')}</h3>
            <small>{i18n.t('checkout.pickupOrderSubmitWaiterConf')}</small>
          </div>
        </div>
        {!!storeMobx.storeSceneConfig.memberConfirmOrders &&
          !checkoutMobx.isMemberLogin ? (
            <a className='cwf-link' data-cypid='cartWaiterLogin' onClick={() => history.push('/login')}>{i18n.t('checkout.memberLoginFastOrder')}</a>
          ) : null}
        <div
          className='cwf-btn'
          data-cypid='cartWaiterMenu'
          onClick={() => {
            if (history.getPrevState() === '/menu') {
              history.goBack()
            } else {
              history.replace('/menu')
            }
          }}
        >
          {i18n.t('cart.addMoreItems')}
        </div>
      </div>
    </div>
  )
}

export default PickupWaiter
